import { h } from 'preact';

import Loadable from 'react-loadable';

export default Loadable({
    loader: () => import('../../../../q-cars/src/containers/PaymentSuccess/paymentPage.js'),
    loading: () => <div></div>,
    render(loaded,props) {
        let Success = loaded.default;
        return <Success {...props} />;
    }
});


// WEBPACK FOOTER //
// ../q-cars/src/containers/PaymentSuccess/index.js